import React, { Component } from 'react'

export default class Footer extends Component {
    ScroolToTop = () =>{
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    render() {
        return (
            <footer className="copyright">
                <div className="up" id="up" onClick= {this.ScroolToTop}>
                    <i className="fas fa-chevron-up" onClick= {this.ScroolToTop}></i>
                </div>
                <p> &copy; 2020 Henri-Pierre Goder</p>
            </footer>
        )
    }
}
